function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { categoryApi } from '@/api/store';
import { categorySaveApi, categoryListApi, categoryUpdateApi, categoryDeleteApi } from '@/api/companyappApi.js';
export default {
  name: 'bandCate',
  data: function data() {
    return {
      dialogFormVisible: false,
      drawerVisible: false,
      tableData: [],
      form: {}
    };
  },
  methods: {
    open: function open(row) {
      this.form.customerId = row.customerId;
      this.getCategoryList();
      this.drawerVisible = true;
    },
    close: function close() {
      this.drawerVisible = false;
    },
    dialogOpen: function dialogOpen(row) {
      this.form = _objectSpread(_objectSpread({}, this.form), {}, {
        cateName: row.name,
        image: row.extra,
        cateId: row.id,
        id: row.customerCategoryId
      });
      console.log(this.form, 'tis.for');
      this.dialogFormVisible = true;
    },
    dialogClose: function dialogClose() {
      this.dialogFormVisible = false;
    },
    onchangeStatus: function onchangeStatus(row) {
      row.customerCateStatus ? this.saveCate(row) : this.deleteCate(row);
    },
    edit: function edit(row) {
      this.dialogOpen(row);
    },
    handleRemove: function handleRemove() {
      this.form.image = '';
    },
    upLoad: function upLoad() {
      var that = this;
      this.$modalUpload(function () {
        var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        that.form.image = data[0].sattDir;
      });
    },
    getCategoryList: function () {
      var _getCategoryList = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var res, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              _context.p = 0;
              _context.n = 1;
              return categoryApi({
                status: -1,
                type: 8
              });
            case 1:
              res = _context.v;
              this.tableData = res;
              this.getCustomerCategoryList();
              _context.n = 3;
              break;
            case 2:
              _context.p = 2;
              _t = _context.v;
              this.$message.error('获取分类信息失败！');
            case 3:
              return _context.a(2);
          }
        }, _callee, this, [[0, 2]]);
      }));
      function getCategoryList() {
        return _getCategoryList.apply(this, arguments);
      }
      return getCategoryList;
    }(),
    getCustomerCategoryList: function () {
      var _getCustomerCategoryList = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var params, res, ids, _t2;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              _context2.p = 0;
              params = {
                customerId: this.form.customerId
              };
              _context2.n = 1;
              return categoryListApi(params);
            case 1:
              res = _context2.v;
              ids = res === null || res === void 0 ? void 0 : res.map(function (item) {
                return item.cateId;
              });
              this.tableData = this.tableData.map(function (item) {
                var index = ids.indexOf(item.id);
                if (index !== -1) {
                  item = _objectSpread(_objectSpread({}, item), {}, {
                    name: res[index].cateName,
                    extra: res[index].image,
                    customerCateStatus: true,
                    customerCategoryId: res[index].id
                  });
                }
                return item;
              });
              _context2.n = 3;
              break;
            case 2:
              _context2.p = 2;
              _t2 = _context2.v;
              this.$message.error(_t2);
            case 3:
              return _context2.a(2);
          }
        }, _callee2, this, [[0, 2]]);
      }));
      function getCustomerCategoryList() {
        return _getCustomerCategoryList.apply(this, arguments);
      }
      return getCustomerCategoryList;
    }(),
    deleteCate: function () {
      var _deleteCate = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(row) {
        var _t3;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.p = _context3.n) {
            case 0:
              _context3.p = 0;
              _context3.n = 1;
              return categoryDeleteApi({
                customerCategoryId: row.customerCategoryId
              });
            case 1:
              this.getCustomerCategoryList();
              this.$message.success('保存成功');
              _context3.n = 3;
              break;
            case 2:
              _context3.p = 2;
              _t3 = _context3.v;
              row.customerCateStatus = !row.customerCateStatus;
              this.$message.error(_t3);
            case 3:
              return _context3.a(2);
          }
        }, _callee3, this, [[0, 2]]);
      }));
      function deleteCate(_x) {
        return _deleteCate.apply(this, arguments);
      }
      return deleteCate;
    }(),
    saveCate: function () {
      var _saveCate = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(row) {
        var params, _t4;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.p = _context4.n) {
            case 0:
              _context4.p = 0;
              params = {
                customerId: this.form.customerId,
                categoryId: row.id
              };
              _context4.n = 1;
              return categorySaveApi(params);
            case 1:
              this.getCustomerCategoryList();
              this.$message.success('保存成功');
              _context4.n = 3;
              break;
            case 2:
              _context4.p = 2;
              _t4 = _context4.v;
              row.customerCateStatus = !row.customerCateStatus;
              this.$message.error(_t4);
            case 3:
              return _context4.a(2);
          }
        }, _callee4, this, [[0, 2]]);
      }));
      function saveCate(_x2) {
        return _saveCate.apply(this, arguments);
      }
      return saveCate;
    }(),
    submit: function () {
      var _submit = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
        var _t5;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.p = _context5.n) {
            case 0:
              _context5.p = 0;
              _context5.n = 1;
              return categoryUpdateApi(this.form);
            case 1:
              this.getCustomerCategoryList();
              this.$message.success('保存成功');
              this.dialogClose();
              _context5.n = 3;
              break;
            case 2:
              _context5.p = 2;
              _t5 = _context5.v;
              this.$message.error(_t5);
            case 3:
              return _context5.a(2);
          }
        }, _callee5, this, [[0, 2]]);
      }));
      function submit() {
        return _submit.apply(this, arguments);
      }
      return submit;
    }()
  }
};